// extracted by mini-css-extract-plugin
export default {"header":"AdminHeader_header__JyG2A","separator":"AdminHeader_separator__CzAz4","nav":"AdminHeader_nav__qzbAR"};